let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7wi5E")).then(() => parcelRequire('8HTcg'));